import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { contentCollectionFormSelector } from "@air/feature-content-collection/redux";
import { useAirModal } from "@air/provider-modal";
import { useShortIdContext } from "@air/provider-short-id";
import { memo, useEffect } from "react";
import { useSelector } from "react-redux";
import { usePublicPageViewNotification } from "~/components/AirNotifications/hooks/usePublicPageViewNotification";
import { BoardCollectionDropzone } from "~/components/BoardCollection/BoardCollectionDropzone";
import { BoardCollectionHero } from "~/components/BoardCollection/BoardCollectionHero";
import { useAlertOnUnsubmittedCCForm } from "~/components/BoardCollection/hooks/useAlertOnUnsubmittedCCForm";
import { ContentCollectionUploadsManager } from "~/components/ContentCollection/ContentCollectionUploadsManager";
import { ContentCollectionViewManager } from "~/components/ContentCollection/ContentCollectionViewManager";
import { ContentCollectionAnonymousSignUpModal } from "~/components/PublicLinkAnonymousSignUpModal/ContentCollectionAnonymousSignUpModal";
import { ROOT_ELEMENT_ID } from "~/hooks/useMouseSelection";
import { useOnMissingUserSession } from "~/hooks/useOnMissingUserSession";
import { useAccountContext } from "~/providers/AccountProvider";
export const ContentCollectionWrapper = /*#__PURE__*/ memo((param)=>{
    let { requireAccount } = param;
    const { shortId } = useShortIdContext();
    const { data: account } = useAccountContext();
    const [showAnonymousSignupModal] = useAirModal(ContentCollectionAnonymousSignUpModal);
    const { sendPublicPageViewEvent } = usePublicPageViewNotification();
    const form = useSelector(contentCollectionFormSelector);
    useOnMissingUserSession({
        onMissingSession: ()=>showAnonymousSignupModal({}),
        enabled: requireAccount
    });
    useEffect(()=>{
        if (!requireAccount || requireAccount && !!account) {
            sendPublicPageViewEvent(shortId);
        }
    }, [
        account,
        requireAccount,
        sendPublicPageViewEvent,
        shortId
    ]);
    useAlertOnUnsubmittedCCForm();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BoardCollectionDropzone, {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex h-full flex-col bg-grey-3",
                    id: ROOT_ELEMENT_ID,
                    children: [
                        (form === null || form === void 0 ? void 0 : form.workspace) && /*#__PURE__*/ _jsx(BoardCollectionHero, {
                            account: account,
                            workspace: form.workspace
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex-1 overflow-hidden",
                            id: "main",
                            children: /*#__PURE__*/ _jsx(ContentCollectionViewManager, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ContentCollectionUploadsManager, {})
        ]
    });
});
ContentCollectionWrapper.displayName = "ContentCollectionWrapper";
